import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Lecturer from "./pages/Lecturer";
import Student from "./pages/Student";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/lecturer" element={<Lecturer />} />
        <Route path="/student" element={<Student />} />
      </Routes>
    </Router>
  );
}

export default App;
